exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".custom-date-picker-input-group{width:100%}.custom-date-picker-input-group .custom-date-picker-input{cursor:pointer;border:1px solid #545454;font-size:1rem}.custom-date-picker-input-group .custom-date-picker-input[readonly]{background-color:#fff}.custom-date-picker-input-group .custom-date-picker-input-icon{position:absolute;top:1px;right:0;width:40px;height:33px;line-height:16px;z-index:3;pointer-events:none;color:#212120;background-color:#fff;border-bottom:1px solid #545454;border-right:1px solid #545454}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/form/FormDatepicker/CustomDatePickerInput.scss
 ** module id = 1240
 ** module chunks = 0
 **/